import React from 'react';
import { motion } from 'framer-motion';
import { SingleBulletCarousel } from './SingleBulletCarousel';
import { HerDemoVideo } from './HerDemoVideo';

// "Cómo funciona": sección de confianza basada solo en hechos del producto.
// Reemplaza a la sección de testimonios en la landing; components/TestimonialsSection.tsx
// queda intacto y sin renderizarse.
//
// REGLA: solo se afirma lo que la compradora recibe HOY. La experiencia diaria interactiva
// (Día 1 → Día 21) todavía es un prototipo de la Fase H: no se promete acá hasta que se entregue.
// Hoy lo interactivo y optimizado para el celular es el Recetario; el resto es ebook digital.
//
// En lugar de "H.E.R. es para vos si… / H.E.R. no es…" (plantilla de segmentación), se parte de la
// situación y la necesidad: "¿En qué momento estás?" → "H.E.R. puede acompañarte si buscás…" → aclaración.
const STEPS = [{
  num: '01',
  title: 'Elegís tu acceso',
  text: 'Dejás tu email y completás el pago con Mercado Pago, en un solo pago o en cuotas.'
}, {
  num: '02',
  title: 'Recibís tu acceso por email',
  text: 'Con el Protocolo H.E.R. de 21 días y las herramientas que lo acompañan.'
}, {
  num: '03',
  title: 'Seguís el recorrido a tu ritmo',
  text: 'Tres fases de 7 días (días 1–7, 8–14 y 15–21), con comida, movimiento y descanso en cada una.'
}];
const RECORRIDO = ['Protocolo H.E.R. · 21 días', 'Tracker H.E.R.'];
const KIT = ['Recetario H.E.R. · 63 recetas', 'H.E.R. Movement', 'Noche en Calma', 'Guía de compras Argentina'];
const MOMENTO = ['Sentís que tu cuerpo cambió y lo que antes te funcionaba ya no alcanza.', 'Querés comer mejor, pero estás cansada de sumar reglas y restricciones.', 'Sabés que necesitás moverte y descansar, pero te cuesta encontrar una rutina que puedas sostener.', 'Leés consejos por todos lados, pero seguís sin saber cómo llevarlos a tu día a día.'];
const PUEDE_ACOMPANARTE = ['Un recorrido concreto para empezar sin tener que decidir por dónde arrancar.', 'Herramientas para observar cómo te sentís y registrar tu propio proceso.', 'Una combinación de alimentación, movimiento y descanso reunida en un mismo lugar.', 'Una estructura de 21 días que después podés adaptar a tu ritmo.'];
function ItemList({
  items
}: {
  items: string[];
}) {
  return <ul className="mt-3 space-y-2.5" data-id="element-316" data-mp="1b0knhtzjh8in">
      {items.map(item => <li key={item} className="flex gap-2.5 font-body text-[14.5px] leading-snug text-[#F0E8D8]/80" data-id="element-317" data-mp="16xxs5j3nt5gp">
          <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-[#C8A870]" aria-hidden="true" data-id="element-318" data-mp="j8bskujdko86" />
          <span data-id="element-319" data-mp="e98ww0pabucv">{item}</span>
        </li>)}
    </ul>;
}
function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="uppercase tracking-[0.22em] text-[#C8A870]" style={{
    fontSize: '12.5px',
    fontFamily: 'sans-serif',
    fontWeight: 600
  }} data-id="element-320" data-mp="s9a0vp0ujhwk">
      {children}
    </p>;
}
const fade = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.55
  }
};
export function HowItWorksSection() {
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: '0px'
  }} data-id="element-321" data-mp="2775w1n94ptht">
      <div className="mx-auto max-w-2xl space-y-8" data-id="element-322" data-mp="2b4bpnf9ayhux">
        <motion.div {...fade} className="space-y-3 text-center" data-id="element-323" data-mp="1x7x4t25nesz5">
          
          
        </motion.div>

        

        {/* Tu recorrido / Tu kit */}
        <motion.div {...fade} className="grid gap-4 md:grid-cols-2" data-id="element-324" data-mp="2pvkkc2s2atex">
          
          
        </motion.div>
        

        {/* Tu ebook digital: solo lo que se recibe hoy */}
        

        {/* ¿En qué momento estás? */}
        <motion.div {...fade} data-id="element-325" data-mp="2g6j5wh160k32">
          <Eyebrow data-id="element-326" data-mp="2g5hire6vk74z">¿En qué momento estás?</Eyebrow>
          <p className="mt-2 font-display text-[22px] font-semibold leading-tight text-[#F0E8D8]" data-id="element-327" data-mp="2l4ax18tzk267">
            Quizás te pase que…
          </p>
          <ItemList items={MOMENTO} data-id="element-328" data-mp="38su2zhpkc2v4" />
          <p className="mt-5 font-display text-[17px] font-medium italic leading-snug text-[#C8A870]" data-id="element-329" data-mp="3dl560tflo4rw">
            No necesitás más consejos sueltos. Necesitás una forma de organizarlos.
          </p>
        </motion.div>

        <div className="divider-fine mx-auto w-16" data-id="element-330" data-mp="1kxh969b5x7bh" />

        {/* Video de demostración: así se ve H.E.R. por dentro (inmediatamente debajo de "¿En qué momento estás?") */}
        <HerDemoVideo data-id="element-331" data-mp="1azjb6u3i3w5o" />

        {/* H.E.R. puede acompañarte si buscás… */}
        

        {/* Una aclaración importante (misma definición que la Guía) */}
        

        

        
      </div>
    </section>;
}